export function isFile(file) {
  return file.__proto__ === File.prototype
}